import type { Settlement, SettlementTools } from '../types';

export function returnUnusedTools(settlement: Settlement): void {
    const returnExtra = (jobKey: keyof SettlementTools, desired: number) => {
        const tools = settlement.tools[jobKey];
        while (tools.length > desired) {
            const tool = tools.pop();
            if (!tool) break;
            settlement.inventory.tools.push(tool);
        }
    };
    returnExtra('farmers', settlement.jobs.farmers);
    returnExtra('hunters', settlement.jobs.hunters);
}
